import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { painPoints } from '../../data/content';
const questions = ['What should I review?', 'In what order?', 'What should I document?', 'What should I verify before moving forward?', 'How do I keep the case organized?'];
export function PainPoints() {
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-248" data-mp="2hkhz5majn0i7">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-249" data-mp="2hj6z9xk7ycwd">
        <SectionHeading eyebrow="Sound familiar?" title="Do any of these sound familiar?" subtitle="If you answer yes to any of them, ALIGNER CONTROL SYSTEM™ was created for you." data-id="element-250" data-mp="2clngqlghndym" />

        <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-251" data-mp="2mjbelk9e51l0">
          {painPoints.map(point => <li key={point.text} className="flex h-full flex-col rounded-2xl border border-navy-100 bg-white p-5" data-id="element-252" data-mp="w7njxjcxw4fl">
              <span className="text-2xl" aria-hidden="true" data-id="element-253" data-mp="1n8bq9shd73vo">
                {point.icon}
              </span>
              <p className="mt-3 text-sm leading-relaxed text-navy-700 sm:text-base" data-id="element-254" data-mp="1s64x8nqhs1x0">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl border-l-4 border-sky-500 bg-white p-6 sm:p-8" data-id="element-255" data-mp="21wptw5mluwda">
          <h3 className="font-display text-xl font-black uppercase leading-tight text-navy-800 sm:text-2xl" data-id="element-256" data-mp="26w2lt4sc2tmq">
            The problem isn’t a lack of information.
            <br data-id="element-257" data-mp="2azh6i8r7vy6i" />
            It’s the lack of a system to organize it.
          </h3>
          <p className="mt-4 text-base leading-relaxed text-navy-600" data-id="element-258" data-mp="2fxaaqw8ymi45">
            You can have hundreds of pages of information. But when you’re
            reviewing a case, you need to know:
          </p>
          <ul className="mt-4 flex flex-col gap-2" data-id="element-259" data-mp="lkarmt5df5s4">
            {questions.map(question => <li key={question} className="text-sm font-semibold text-navy-800 sm:text-base" data-id="element-260" data-mp="qhsxgao3d4vw">
                → {question}
              </li>)}
          </ul>
          <p className="mt-4 text-base leading-relaxed text-navy-600" data-id="element-261" data-mp="ehmbpirgw004">
            That’s what ALIGNER CONTROL SYSTEM™ is designed to help you
            structure.
          </p>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-262" data-mp="niaqwgslk6el">
          <CTAButton label="I want the system" data-id="element-263" data-mp="11enxuvzi8pet" />
        </div>
      </div>
    </section>;
}